import React from "react";
import { Link } from "react-router-dom";
import { Label, Grid, Row, Col } from "react-bootstrap";
import EntityDetailsModal from "../../modal-views/EntityDetailsModal";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";
import { StoreContext } from "../../contexts/StoreContext";
import { inject, observer } from "mobx-react";

const ITEMS_VIEW_LIMIT = 3;

@inject("popupStore")
@observer
export class CombinationItem extends React.Component {
  state = {
    showVariableDetailsModal: false,
    variableToshow: null,
    validityDate: null,
  };

  handleToggleVariableDetailsModal = (e, detailsItem) => {
    e?.preventDefault();
    const entityData = this.context.entityData;
    this.setState((oldState) => ({
      ...oldState,
      showVariableDetailsModal: !oldState.showVariableDetailsModal,
      variableToshow: detailsItem,
      validityDate: entityData?.item?.object?.validFrom,
    }));
    return false;
  };
  static contextType = StoreContext;
  render() {
    const { item } = this.props;
    if (!item.items || !item.items.length) {
      return null;
    }

    const { variableToshow } = this.state;

    const variable = item.items.find((x) => x.object.type === "Variable");
    const subdomain = item.items.find((x) => x.object.type === "Subdomain");
    const variableSet = item.items.find((x) => x.object.type === "VariableSet");
    const member = item.items.find((x) => x.object.type === "Member");

    let detailsItem = null;
    let items = null;
    let facetCollection = null;

    if (variableSet) {
      detailsItem = variableSet;
      items =
        variableSet.items && variableSet.items.length
          ? variableSet.items // variable set enumerations
              .map((vseItem) => vseItem.items) // nested items
              .reduce((acc, it) => [...acc, ...it]) // flatten list of nested items (subdomains, variables)
              .filter((x) => x.object.type === "Variable") // keep only variables
          : null;
    } else if (member) {
      detailsItem = member;
      items = [];
    } else if (subdomain) {
      facetCollection =
        subdomain.items &&
        subdomain.items.find((x) => x.object.type === "FacetCollection");
      if (facetCollection) {
        detailsItem = subdomain;
      } else {
        detailsItem = subdomain;
        items =
          subdomain.items && subdomain.items.length
            ? subdomain.items
                .filter((enumItem) => enumItem.items)
                .map((enumItem, key) => enumItem.items)
                .map((x) => x[0])
            : null;
      }
    }

    if (!detailsItem) {
      return null;
    }

    return (
      <Grid className="combination-item" fluid={true}>
        <Row>
          <Col xs={6}>
            <ul>
              {variable ? (
                <p>
                  <br></br>
                  <p>
                    <Link
                      to={`/view/${variable.object.type}/${variable.object.tid}`}
                      target={"_blank"}
                    >
                      {`${variable.object.name || "[No name]"}`}
                    </Link>
                    {` (${variable.object.code})`}
                    <Label className="object-type" bsStyle="success">
                      {variable.object.type}
                    </Label>
                    {variable.object.maintenanceAgencyId ? (
                      <MaintenanceAgencyLabel
                        maintenanceAgencyId={
                          variable.object.maintenanceAgencyId
                        }
                      ></MaintenanceAgencyLabel>
                    ) : (
                      ""
                    )}
                  </p>
                </p>
              ) : null}
              {variable ? (
                <ul>
                  <li>
                    <p>{variable.object.description || ""}</p>
                    <ul>
                      {item.object.description && (
                        <li>
                          <p>{item.object.description || ""}</p>
                        </li>
                      )}
                    </ul>
                  </li>
                </ul>
              ) : null}
            </ul>
          </Col>

          <Col xs={6}>
            <ul>
              <li>
                {
                  // Only display Subdomain description if there are no enumerated items
                  items && items.length > 0 ? null : (
                    <React.Fragment>
                      <p>
                        <Link
                          to={`/view/${detailsItem.object.type}/${detailsItem.object.tid}`}
                          target={"_blank"}
                        >
                          {`${detailsItem.object.name || "[No name]"}`}
                        </Link>
                        {` (${detailsItem.object.code})`}
                        <Label className="object-type" bsStyle="success">
                          {detailsItem.object.type}
                        </Label>
                        {detailsItem.object.maintenanceAgencyId ? (
                          <MaintenanceAgencyLabel
                            maintenanceAgencyId={
                              detailsItem.object.maintenanceAgencyId
                            }
                          ></MaintenanceAgencyLabel>
                        ) : (
                          ""
                        )}
                      </p>
                    </React.Fragment>
                  )
                }

                {(items && items.length) || facetCollection ? (
                  <div>
                    <ul>
                      {items &&
                        items.length &&
                        items
                          .slice(0, ITEMS_VIEW_LIMIT)
                          .map((detailSubitem, index) => (
                            <li key={index}>
                              <p>
                                <Link
                                  to={`/view/${detailSubitem.object.type}/${detailSubitem.object.tid}`}
                                  target={"_blank"}
                                >
                                  {`${
                                    detailSubitem.object.name || "[No name]"
                                  }`}
                                </Link>
                                {` (${detailSubitem.object.code})`}
                                <Label
                                  className="object-type"
                                  bsStyle="success"
                                >
                                  {detailSubitem.object.type}
                                </Label>
                                {detailSubitem.object.maintenanceAgencyId ? (
                                  <MaintenanceAgencyLabel
                                    maintenanceAgencyId={
                                      detailSubitem.object.maintenanceAgencyId
                                    }
                                  ></MaintenanceAgencyLabel>
                                ) : (
                                  ""
                                )}
                              </p>
                            </li>
                          ))}
                      {items && items.length && items.totalCountOfItems > 0 && (
                        <Link
                          className="btn btn-link VariableDetailsModalToggleButton"
                          to={`/view/${detailsItem.object.type}/${detailsItem.object.tid}`}
                          target={"_blank"}
                        >
                          show all ...{" "}
                          {detailsItem &&
                          detailsItem.totalCountOfItems > ITEMS_VIEW_LIMIT
                            ? `(total ${detailsItem.totalCountOfItems} items)`
                            : ""}
                        </Link>
                      )}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                {this.state.showVariableDetailsModal && (
                  <StoreContext.Provider value={this.props.popupStore}>
                    <EntityDetailsModal
                      cubeVariableName={variable.object.name || "[No name]"}
                      cubeVariableCode={item.object.cubeVariableCode}
                      details={variableToshow ? variableToshow : detailsItem}
                      onClose={(e) => {
                        this.handleToggleVariableDetailsModal(e, detailsItem);
                      }}
                    />
                  </StoreContext.Provider>
                )}
              </li>
            </ul>
          </Col>
        </Row>
      </Grid>
    );
  }
}
